import { formatCurrency, formatNumber, formatPercent } from '@/lib/utils'

export default function PlanFieldDelta({ value, compareValue, show, format = 'number' }) {
  if (!show || compareValue === undefined || compareValue === null) return null
  const diff = (value || 0) - (compareValue || 0)
  if (!diff) return <span className="ml-1.5 text-xs font-medium text-muted-foreground">same</span>
  const prefix = diff > 0 ? '+' : ''
  const body = format === 'currency' ? `${prefix}${formatCurrency(diff)}`
    : format === 'percent' ? `${prefix}${formatPercent(diff)}`
    : `${prefix}${formatNumber(diff)}`
  return <span className={`ml-1.5 text-xs font-medium ${diff > 0 ? 'text-emerald-700' : 'text-red-700'}`}>{body}</span>
}
